import { action, flow } from 'mobx'

let store = {}

export const initActionCreator = (initialStore) => (store = initialStore)

export const createAction = (fn) => action(fn)(store)

export const createFlow = (fn) => flow(fn)(store)

export const withStore = (fn) => fn(store)
